<template>
  <template v-if="data">
    <TirPmTableTd
      class="pointer"
      style="overflow: hidden; min-width: 100px"
      @click="onClickDetail"
      :is-left-border="false"
    >
      {{ moment(data.StartDate).format("DD-MM-YYYY HH:mm:ss.SSS") }}
    </TirPmTableTd>
    <TirPmTableTd class="pointer" @click="onClickDetail">
      {{ data.JobName }}
    </TirPmTableTd>
    <TirPmTableTd class="pointer" @click="onClickDetail">
      <ScheduleStatus :typeName="data.Status" isFullSize />
    </TirPmTableTd>
    <TirPmTableTd>
      {{ data.Massage }}
    </TirPmTableTd>
  </template>
</template>

<script setup lang="ts">
// Импорты из Vue 3 Composition API
import DropdownItemModel from "@/pages/_uc/dropdown-multiselect/dropdownModel";
import moment from "moment";
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmStatus,
  TirPmTableTd,
} from "tir-components";
import {
  PencilSquareIcon,
  AdjustmentsVerticalIcon,
  TrashIcon,
  PlusIcon,
  PaperClipIcon,
  WindowIcon,
  ArrowUturnLeftIcon,
  ArrowUturnRightIcon,
} from "tir-style-system/icons/outline/";

import {
  ref,
  computed,
  defineProps,
  defineEmits,
  onMounted,
  watch,
  PropType,
} from "vue";

import TirLink from "@/pages/_uc/vue3-tir-link/tir-link.vue";

import { PaintIcon } from "tir-style-system/icons/solid";
import UserDate from "@/pages/job/components/user-date.vue";
import { ScheduleStatus } from "@/pages/_uc/schedule-status";

// Определение пропсов компонента
const props = defineProps({
  data: {
    type: Object as PropType<any>,
  },
});

// Определение эмиттеров событий компонента
const emits = defineEmits<{
  clickAction: [any]; // Событие при клике
  clickDetail: [any]; // Событие при клике
  clickRemove: [any]; // Событие при клике
}>();

function onClickDetail() {
  emits("clickDetail", props.data);
}
</script>

<style lang="scss"></style>
